import { render, staticRenderFns } from "./CustomerWsuExtend.vue?vue&type=template&id=e08220a0&scoped=true&"
import script from "./CustomerWsuExtend.vue?vue&type=script&lang=js&"
export * from "./CustomerWsuExtend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08220a0",
  null
  
)

export default component.exports